import styled from 'styled-components/macro'

export const AddressWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;

  .textInput {
    width: 45%;
  }

  .dropdown {
    width: 45%;
  }

  .numberInput {
    width: 45%;
  }
`
